var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5fe1d8",
    d: "M765.446+61.6434L265.335+61.6434C225.897+61.6434+193.89+99.1672+193.89+145.402L193.89+942.778C193.89+964.984+207.558+971.271+224.419+956.819L485.836+732.75C502.697+718.298+529.998+718.339+546.815+732.841L806.44+956.728C823.257+971.23+836.89+964.984+836.89+942.778L836.89+145.402C836.89+99.1672+804.883+61.6434+765.446+61.6434Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe249",
    d: "M564.108+384.645L622.566+386.29C633.328+386.592+635.153+392.336+626.642+399.118L580.202+436.129C571.692+442.911+567.247+457.024+570.275+467.651L586.908+526.026C589.936+536.653+585.209+540.168+576.349+533.876L528.041+499.566C519.182+493.275+504.819+493.276+495.961+499.57L447.648+533.897C438.79+540.191+434.064+536.678+437.092+526.052L453.725+467.676C456.753+457.049+452.308+442.936+443.798+436.154L397.358+399.143C388.847+392.361+390.672+386.618+401.434+386.315L459.892+384.67C470.654+384.367+482.279+375.655+485.858+365.211L505.52+307.833C509.099+297.389+514.902+297.389+518.482+307.833L538.14+365.186C541.72+375.63+553.346+384.342+564.108+384.645Z",
    opacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.937ec81852c93071c65145a592064411.svg";
export { ForwardRef as ReactComponent };